module.exports = {
    "page.im.window.label.totalItems": "Total items",
    "im.messageList.whereIsMyOrderTitle": "My Recent Order",
    "page.im.window.label.sellerSku": "Seller SKU",
    "page.im.window.label.emptyList": "Oh no, the buyer hasn't purchased anything from your shop yet.",
    "page.im.window.voucher.sendBatch.choose": "Please choose which follower-exclusive voucher to send.",
    "page.import.historyBox.search.action": "Action",
    "lazada_im_sticker_like": "Like",
    "page.import.historyBox.col.filename": "File Name",
    "page.im.setting.management.title": "Customer Support",
    "page.im.setting.title": "Chat Settings",
    "page.im.window.follow.notFollow": "This customer is not your follower yet.",
    "page.im.window.messageInputPlaceholder": "Type message here, Enter to send message",
    "page.im.setting.btn.createUser": "Create a New Full Access User",
    "page.im.setting.btn.clear": "Clear selected",
    "page.im.window.discount.cashLabelSuffix": "OFF",
    "page.im.setting.init.confirm": "Once assigned, the Primary Chat Account cannot be edited or delete. Please make sure you have submitted the correct account.",
    "page.im.window.voucher.sendBatch.desc": "You are about to send a Follower-exclusive voucher to followers,\r\n    every one who reaceives the message can use this voucher.",
    "page.import.historyBox.col.status": "Status",
    "page.im.window.get": "Get",
    "page.im.window.label.returnReason": "Return reason",
    "page.import.importBox.templateTitle": "Download Templates",
    "page.im.window.follow.send": "Send Invite",
    "page.im.window.tab.voucher": "Voucher",
    "lazada_im_sticker_no": "NO",
    "im.messageList.unpaidOrderTitle": "Unpaid Order Reminder",
    "page.import.importBox.importModeText": "Import Mode",
    "page.im.window.tab.order": "Order",
    "page.im.window.orderSearchPlaceholder": "Please input search value",
    "lazada_im_sticker_kisses": "Kisses",
    "page.im.window.units": "units",
    "page.im.window.discount.cashLabelPrefixLine2": "Value",
    "page.im.setting.assignment.subTitle": "Please assign the login that will be in charge of your chat accounts. It will be the only one able to see all your chats if you have multiple users. NOTE once it is submitted this account cannot be changed",
    "page.im.setting.assignment.title": "Assign your primary chat account",
    "page.im.window.label.productId": "Product ID",
    "page.im.window.label.pending": "pending",
    "lazada_im_sticker_giftforyou": "Gift for you",
    "im.messageList.reviewShippingInformationTitle": "Review Your Shipping Address",
    "page.import.historyBox.col.user": "User",
    "page.import.import": "Import",
    "im.messageList.reviewShippingInformationAddress": "Shipping address",
    "im.messageList.returnRequestTitle": "New Return Request",
    "im.messageList.followTitle": "Follow our store",
    "page.im.window.process.resend": "Resend",
    "page.im.setting.btn.selectAll": "from all pages",
    "page.im.window.translation.advertisements": "Alibaba Translation",
    "page.import.historyBox.processed.table.col.failure": "Failure",
    "page.im.window.label.all": "All",
    "im.messageList.returnReason": "Return reason",
    "im.messageList.lazMall": "LazMall",
    "page.im.setting.confirm": "Are you sure to remove user from this group",
    "page.im.setting.tab1": "User Management",
    "page.im.window.tab.collectiveVoucher": "Collective Voucher",
    "im.messageList.status": "Status",
    "page.import.historyBox.processed.table.col.sucess": "Success",
    "page.im.window.read": "Read",
    "page.im.setting.action": "Xiaobai Test",
    "im.messageList.productTitle": "Product Information",
    "lazada_im_sticker_peep": "Peep",
    "page.import.importBox.importButton": "Upload Files",
    "page.im.window.label.productName": "Product Name",
    "page.im.setting.assignment.placeholder": "Email, User Name",
    "page.im.window.label.returning": "returning",
    "im.messageList.change": "Change",
    "page.im.window.defaultText": "Unknown message type.",
    "page.import.historyBox.link.download": "Download",
    "page.im.setting.btn.remove": "Remove",
    "page.im.window.label.read": "Read",
    "page.import.historyBox.col.created": "Created",
    "page.import.title": "Import",
    "page.im.setting.btn.addUser": "Add User",
    "page.import.importBox.infos.1": "To create or upload products you can use CSV files (.csv) or MS Excel documents (.xlsx).",
    "page.im.window.label.status": "Status",
    "page.im.window.follow": "Follow",
    "page.import.historyBox.feedback.success": "Your import is finished",
    "page.im.window.draft": "DRAFT",
    "lazada_im_sticker_buybuybuy": "Buy Buy Buy!",
    "page.im.window.label.loading": "Loading",
    "im.messageList.voucherBtn": "Collect",
    "page.im.window.prdSearchPlaceholder": "Please input search value",
    "page.im.window.label.unread": "Unread",
    "lazada_im_sticker_vouchers": "Vouchers",
    "page.import.historyBox.processed.table.col.warning": "Warning",
    "page.im.window.send": "Send",
    "page.im.window.label.totalReturns": "Total returns",
    "page.im.window.sessionFilterPlaceholder": "Search customer name...",
    "page.import.historyBox.col.progress": "Progress",
    "lazada_im_sticker_thankyou": "Thank you",
    "im.messageList.unpaidOrderItemTip": "Total items",
    "page.im.window.tab.product": "Product",
    "page.import.importBox.infos.3": "Encoding format: UTF-8, separator: semicolon",
    "page.im.window.label.total": "Total",
    "im.message.unknownMessage": "Sorry, certain new types of messages aren't supported on a PC. To view these messages, please download the AliExpress app. Thank you!",
    "page.im.window.filter.read": "Read Messages",
    "page.im.window.oversize": "The file is too large to upload(smaller than 50M)",
    "page.im.window.filter.all": "All Messages",
    "page.im.window.discount.rateLabel": "%",
    "lazada_im_sticker_shoppingday": "Shopping day",
    "page.im.setting.tab2": "Quick Reply",
    "im.messageList.payNow": "Pay Now",
    "page.im.window.label.refresh": "Refresh",
    "page.import.historyBox.col.type": "File Name",
    "page.import.footer.button.another": "Import Another",
    "page.import.historyBox.link.downloadErrorReport": "Download Error Report",
    "im.messageList.order": "Order",
    "im.messageList.reviewShippingInformationItemTip": "Total item",
    "page.import.tab.import": "Import",
    "im.messageList.followBtn": "Follow",
    "page.im.window.voucher.sendBatch.creatingTitle": "Creating New Voucher",
    "page.im.window.voucher.sendBatch.createButton": "Create new voucher",
    "lazada_im_sticker_ok": "OK",
    "page.im.setting.imForm.to": "To",
    "page.import.importBox.footerTips": "Description updated using Bulk Upload will not be visible inside Lorikeet. Please download the products into excel file to view such descriptions",
    "page.im.window.voucher.sendBatch.creatingButton": "Create new voucher",
    "page.import.importBox.infos.2": "Note: the Excel file may not contain any formulas or references.",
    "page.im.setting.imForm.from": "From",
    "page.import.footer.button.done": "Done",
    "im.messageList.orderNumber": "Order Number",
    "page.im.window.unread": "Unread",
    "page.im.window.voucher.sendBatch.creatingDesc": "Please do not close this window otherwise the vouchers will not be sent.\r\nPress the confirm button when you finish creating the voucher in the new window.",
    "page.import.tab.template": "Template History",
    "page.im.window.label.orderTime": "Order time",
    "page.im.window.label.order": "Order",
    "page.import.historyBox.col.processed": "Processed",
    "page.im.setting.tab3": "Auto Reply",
    "page.im.window.label.shopSku": "Shop SKU",
    "im.messageList.failedStatus": "Message failed to send. {resend} or {delete}",
    "page.im.window.voucher.sendBatch.errorTip": "Some thing goes wrong:(",
    "page.im.window.label.message": "Chat",
    "page.im.window.date.yesterday": "yesterday",
    "page.import.historyBox.col.action": "Action",
    "page.im.window.label.emptyMessage": "There is no message received.",
    "page.import.historyBox.search.filename": "File Name",
    "page.im.window.view": "View",
    "page.import.tab.history": "Import History",
    "page.im.window.filter.unread": "Unread Messages",
    "page.im.window.app.download": "Use the App for the best Chat experience!",
    "page.im.window.tab.codeVoucher": "Code Voucher",
    "im.messageList.confirm": "Address is accurate.",
    "page.im.window.voucher.sendBatch.submitError": "Follower vouchers haven’t been sent out successfully. Please try again.",
    "im.messageList.view": "View",
    "page.im.window.voucher.sendBatch.title": "Mass Send Vouchers to Followers",
    "im.messageList.totalReturns": "Total returns",
    "page.import.historyBox.search.user": "User",
    "page.import.historyBox.feedback.failed": "Your import is failed",
    "page.im.window.disconnection": "Network disconnection",
    "page.im.window.voucher.sendBatch.submitSuccess": "Follower vouchers will be sent out in few minutes.",
    "im.messageList.unknowMessage": "[Please check this message in your Lazada APP.]",
    "im.messageList.orderDate": "Order date",
    "page.im.setting.current.desc": "from all pages are selected",
    "page.im.window.discount.cashLabelPrefixLine1": "Money"
};